const StoreCurrencyAndPricePlan = `
    general_info.vat,               store_vat;
    general_info.currency,          store_currency;
    pp_name,                        store_price_plan,           true;
    store_flg,                      price_plan,                 false,         0;
`

export default StoreCurrencyAndPricePlan;